import { isMobile } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import * as React from 'react';
import { Collapse } from 'react-collapse';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { PriceDisplay } from '../../../../ReactComponents/PriceDisplay';
import { CartShippingInfoViewModel } from '../../ViewModels/CartShippingInfo/CartShippingInfoViewModel.csharp';

interface CartSummaryFreeDeliveryInfoProps {
    shippingInfo: CartShippingInfoViewModel;
    subTotalWithDiscountsIncludingHelfo: number;
    inlineVersion: boolean;
    deliveryPriceCalculationInfo?: string;
}

export const CartSummaryFreeDeliveryInfo = (props: CartSummaryFreeDeliveryInfoProps) => {
    const [isDeliveryCalculationVisible, setIsDeliveryCalculationVisible] = React.useState<boolean>(false);

    const { amountLeftForFreeDelivery } = props.shippingInfo.cheapestMethodInfo;
    const barValue = props.subTotalWithDiscountsIncludingHelfo / (amountLeftForFreeDelivery + props.subTotalWithDiscountsIncludingHelfo);
    const barPercentage = barValue < 1 ? barValue * 100 : 100;
    const cheapestMethodIsPaid = amountLeftForFreeDelivery > 0;
    const showContainer = barValue >= 1 ? 0 : 1;
    const hideOnCheckout = props.inlineVersion && !cheapestMethodIsPaid;
    const barMargin = isMobile() ? '16px' : '28px';

    const toggleButtonOnClick = () => {
        setIsDeliveryCalculationVisible((prevState) => !prevState);
    };

    React.useEffect(() => {
        if (!cheapestMethodIsPaid) {
            setIsDeliveryCalculationVisible(false);
        }
    }, [cheapestMethodIsPaid]);

    return (
        <>
            {Number.isFinite(amountLeftForFreeDelivery) && (
                <div
                    className={classNames(
                        'CartSummary__FreeDeliveryInfoContainer',
                        hideOnCheckout && 'CartSummary__HideContainer',
                        props.inlineVersion && 'CartSummary__FreeDeliveryInfoContainer--WithGap'
                    )}
                >
                    <div
                        className={classNames(
                            props.inlineVersion ? 'CartSummary__FreeDeliveryInfoMainContentInline' : 'CartSummary__FreeDeliveryInfoMainContentContainer'
                        )}
                    >
                        <div className={classNames(props.inlineVersion ? 'CartSummary__FreeDeliveryInfoInline' : 'CartSummary__FreeDeliveryInfo')}>
                            {cheapestMethodIsPaid ? (
                                <span className="CartSummary__AmountForFreeDelivery">
                                    <div>
                                        <span>
                                            {getTranslation(keys['cartSummary.freeDeliveryNeededAmount'])} <PriceDisplay price={amountLeftForFreeDelivery} />{' '}
                                        </span>
                                        <span>{getTranslation(keys['cartSummary.freeDeliveryGratis'])}</span>
                                    </div>
                                </span>
                            ) : (
                                <span className={classNames('CartSummary__AmountForFreeDelivery', 'CartSummary__CheckMark')}>
                                    {getTranslation(keys['cartSummary.freeDeliveryAchieved'])}
                                </span>
                            )}
                            {!props.inlineVersion && props.deliveryPriceCalculationInfo && cheapestMethodIsPaid && (
                                <button
                                    className={classNames(
                                        'CartSummary__FreeDeliveryInfoToggleIcon',
                                        'CartSummary__FreeDeliveryInfoToggleIcon--Inline',
                                        isDeliveryCalculationVisible && 'CartSummary__FreeDeliveryInfoToggleIcon--Expanded'
                                    )}
                                    aria-label={`${
                                        isDeliveryCalculationVisible
                                            ? getTranslation(keys['cartSummary.freeDeliveryButtonHide'])
                                            : getTranslation(keys['cartSummary.freeDeliveryButtonShow'])
                                    } ${getTranslation(keys['cartSummary.freeDeliveryButtonA11yText'])}`}
                                    onClick={toggleButtonOnClick}
                                    aria-expanded={isDeliveryCalculationVisible}
                                    aria-controls="CartSummaryFreeDeliveryInfoLogic"
                                />
                            )}
                        </div>
                        <div
                            style={{
                                visibility: showContainer ? 'visible' : 'hidden',
                                overflow: showContainer ? '' : 'hidden',
                                margin: props.inlineVersion ? '0' : showContainer ? `8px ${barMargin}` : `0 ${barMargin}`,
                                maxHeight: showContainer ? '500px' : 0,
                                transform: `scaleY(${showContainer})`
                            }}
                            className={classNames(
                                'CartSummary__FreeDeliveryInfoBarContainer',
                                props.inlineVersion && 'CartSummary__FreeDeliveryInfoBarContainerInline'
                            )}
                        >
                            <div style={{ width: `${barPercentage}%` }} className="CartSummary__FreeDeliveryInfoBar"></div>
                        </div>
                    </div>
                    {props.deliveryPriceCalculationInfo && (
                        <div
                            className={classNames(
                                'CartSummary__FreeDeliveryInfoLogicContainer',
                                !props.inlineVersion && 'CartSummary__FreeDeliveryInfoLogicContainer--WithPadding'
                            )}
                        >
                            {props.inlineVersion && (
                                <button
                                    className="CartSummary__FreeDeliveryInfoLogicHeadingButton"
                                    onClick={toggleButtonOnClick}
                                    aria-expanded={isDeliveryCalculationVisible}
                                    aria-controls="CartSummaryFreeDeliveryInfoLogic"
                                >
                                    <span className="CartSummary__FreeDeliveryInfoLogicHeadingText">
                                        {getTranslation(keys['cartSummary.freeDeliveryCalculationHeading'])}
                                    </span>
                                    <div
                                        className={classNames(
                                            'CartSummary__FreeDeliveryInfoToggleIcon',
                                            isDeliveryCalculationVisible && 'CartSummary__FreeDeliveryInfoToggleIcon--Expanded'
                                        )}
                                    />
                                </button>
                            )}
                            <Collapse isOpened={isDeliveryCalculationVisible}>
                                <div className="CartSummary__FreeDeliveryInfoLogicTextWrapper" id="CartSummaryFreeDeliveryInfoLogic">
                                    {props.deliveryPriceCalculationInfo}
                                </div>
                            </Collapse>
                            <div
                                className={classNames(
                                    'CartSummary__FreeDeliveryInfoPaddingBottom',
                                    isDeliveryCalculationVisible && 'CartSummary__FreeDeliveryInfoPaddingBottom--Visible',
                                    props.inlineVersion && 'CartSummary__FreeDeliveryInfoPaddingBottom--Small'
                                )}
                            />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
